import { render, staticRenderFns } from "./OptionsBuilder.vue?vue&type=template&id=97ca6f0c&scoped=true"
import script from "./OptionsBuilder.vue?vue&type=script&lang=js"
export * from "./OptionsBuilder.vue?vue&type=script&lang=js"
import style0 from "./OptionsBuilder.vue?vue&type=style&index=0&id=97ca6f0c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ca6f0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97ca6f0c')) {
      api.createRecord('97ca6f0c', component.options)
    } else {
      api.reload('97ca6f0c', component.options)
    }
    module.hot.accept("./OptionsBuilder.vue?vue&type=template&id=97ca6f0c&scoped=true", function () {
      api.rerender('97ca6f0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-builder/OptionsBuilder.vue"
export default component.exports